// src/redux/registerFormReducer.ts
import { getBaseUrl } from '../../Utils'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

interface RegisterFormState {
    loading: boolean
    successMessage?: string
    errorMessage?: string
}

export interface RegistrationFormData {
    FirstName: string
    LastName: string
    EmailAddress?: string
    Password: string
    ReenterPassword: string
    secId?: string | null
    samAccountName?: string | null
    // RoleId:roleSelect, TODO enable role select
    NationalProviderID?: string
    AgreeTOS?: boolean
    DomainSlashUserid?: string
    authSource?: number | null
    SiteName?: string
}

export interface RegistrationResponse {
    data: any
}

export const registerFormAPI = createApi({
    reducerPath: 'register', //our reducer lives at store.reducer
    tagTypes: ['RegistrationFormData'],
    baseQuery: fetchBaseQuery({ baseUrl: getBaseUrl() + 'API/v3' }), //The base API path
    // The "endpoints" represent operations and requests for this server
    endpoints: (build) => ({
        // The `getPosts` endpoint is a "query" operation that returns data
        submitForm: build.mutation<RegistrationResponse, Partial<RegistrationFormData>>({
            query: (body) => ({
                url: '/Account',
                method: 'POST',
                body,
            }),
        }),
    }),
})

export const { useSubmitFormMutation } = registerFormAPI
// export const registerFormSlice;
